module.exports = __webpack_public_path__ + "static/media/openflo.f161f317.svg";